import * as React from "react";
import * as ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./helpers/arrayExtensions";
import "./styles/site.scss";
import "font-awesome/scss/font-awesome.scss";
import "react-quill/dist/quill.snow.css";
import "codemirror/lib/codemirror.css";
import "codemirror/theme/darcula.css";
import "codemirror/addon/fold/foldgutter.css";
import "codemirror/mode/javascript/javascript.js";
import "codemirror/addon/fold/foldgutter.js";
import "noty/lib/noty.css";

//const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href")!;
const rootElement = document.getElementById("root")!;
// basename={window.location.origin + "/"}
ReactDOM.render(
    <BrowserRouter>
        <App />
    </BrowserRouter>,
    rootElement);